import {SmartComponent} from "smart-component-js";
import Swiper, { Navigation, Pagination } from "swiper";

class ArticleRecipeGalleryComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.gallery = document.querySelector('.article-recipe-gallery');
        this.close = this.gallery.querySelector('.article-recipe-gallery__close');
        this.descriptionWrapper = this.gallery.querySelector('.article-recipe-gallery__descriptions-wrapper');
        this.init();
    }

    initSwiper() {
        const swiperContainer = this.gallery.querySelector(".article-recipe-gallery__images");
        this.swiper = new Swiper(swiperContainer, {
            slidesPerView: 1,
            modules: [Navigation, Pagination],
            navigation: {
                nextEl: this.gallery.querySelector(".article-recipe-gallery__button--next"),
                prevEl: this.gallery.querySelector(".article-recipe-gallery__button--prev"),
            }
        });

        this.swiper.on('activeIndexChange', () => {
            this.descriptionWrapper.style.transform = `translateX(-${this.swiper.activeIndex}00%)`;
        });
    }

    addGalleryListener() {
        this.element.addEventListener('click', () => {
            this.gallery.classList.add('visible');
        });

        this.element.addEventListener('click', () => {
            this.initSwiper();
            this.close.addEventListener('click', () => this.gallery.classList.remove('visible'));
        }, {once: true});
    }


    init() {
        this.addGalleryListener();
    }
}

export default ArticleRecipeGalleryComponent;
